<ng-container *ngIf="currentUserWrapper$ | async as currentUserWrapper">
  <div
    *ngIf="!!preset"
    [class.has-button-overlay-label]="!!buttonOverlayLabel"
    (click)="presetClicked.emit(preset)"
    class="preset-wrapper w-100 h-100"
  >
    <div class="preset-overlay"></div>
    <img
      *ngIf="preset.thumbnail || preset.imageFile"
      [src]="preset.thumbnail || preset.imageFile"
      class="preset-image"
    />
    <img
      *ngIf="!preset.thumbnail && !preset.imageFile"
      class="preset-image default"
      src="/assets/images/equipment-preset.png?v=1"
    />
    <div class="preset-name">
      {{ preset.name }}
    </div>
    <div *ngIf="buttonOverlayLabel" class="button-overlay">
      {{ buttonOverlayLabel }}
    </div>
  </div>

  <button
    *ngIf="!!preset && currentUserWrapper.user?.id === preset.user"
    [class.loading]="loadingService.loading$ | async"
    (click)="onPresetEditClicked(preset)"
    class="btn btn-secondary btn-edit-preset"
  >
    <fa-icon [ngbTooltip]="'Edit' | translate" container="body" icon="pencil"></fa-icon>
  </button>

  <button
    *ngIf="!!preset && currentUserWrapper.user?.id === preset.user"
    [class.loading]="loadingService.loading$ | async"
    (click)="onPresetDeleteClicked(preset)"
    class="btn btn-secondary btn-delete-preset"
  >
    <fa-icon [ngbTooltip]="'Delete' | translate" container="body" icon="trash"></fa-icon>
  </button>
</ng-container>

<ng-template #presetEditOffcanvas let-offcanvas>
  <div class="offcanvas-header">
    <h5 class="offcanvas-title">{{ "Edit setup" | translate }}</h5>
    <button (click)="offcanvas.close()" class="btn-close" aria-label="Close" type="button"></button>
  </div>

  <div class="offcanvas-body">
    <astrobin-equipment-preset-editor
      [preset]="preset"
      (presetSaved)="offcanvas.close()"
    ></astrobin-equipment-preset-editor>
  </div>
</ng-template>
